module.exports = __webpack_public_path__ + "img/logo.c369b3b0.png";